import createIcon from '../../createIcon';

/**
 * @component @name FourgMobiledata
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSA3SDdWMTJINVY3SDNWMTRIN1YxN0g5VjE0SDExVjEySDlWN1pNMTcgMTFWMTNIMTlWMTVIMTRWOUgyMUMyMSA3LjkgMjAuMSA3IDE5IDdIMTRDMTIuOSA3IDEyIDcuOSAxMiA5VjE1QzEyIDE2LjEgMTIuOSAxNyAxNCAxN0gxOUMyMC4xIDE3IDIxIDE2LjEgMjEgMTVWMTFIMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FourgMobiledata = createIcon('FourgMobiledata', [
  [
    'path',
    {
      d: 'M9 7H7V12H5V7H3V14H7V17H9V14H11V12H9V7ZM17 11V13H19V15H14V9H21C21 7.9 20.1 7 19 7H14C12.9 7 12 7.9 12 9V15C12 16.1 12.9 17 14 17H19C20.1 17 21 16.1 21 15V11H17Z',
      key: 'q0debf',
    },
  ],
]);

export default FourgMobiledata;
